import { render } from "./CustomRequirements.vue?vue&type=template&id=021b06b6"
import script from "./CustomRequirements.vue?vue&type=script&lang=js"
export * from "./CustomRequirements.vue?vue&type=script&lang=js"

import "./CustomRequirements.vue?vue&type=style&index=0&id=021b06b6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__